export const getLocalTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
